import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link,useNavigate } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";
import { GetOffer } from "../../api/get";
import { InvitationSendToUser } from "../../api/api";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import * as Yup from "yup";
import { useFormik } from "formik";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FaInfoCircle } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import { handleApiError } from "../../Common/Helper";
const Offers = () => {
  const [contentLoader, setContentLoader] = useState(true);
  const [Offer, setOffer] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    GetOffer()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setOffer(res.data);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container mx-auto p-5">
            <div className="grid grid-cols-2 max-lg:grid-cols-1">
              {/* Left Section */}
              <div>
                <div>
                  <p className="text-[18px] sm:text-[18px] md:text-[20px] lg:text-[22px] font-semibold mb-4">
                    {Offer?.offer_title || "No Title Available"}
                  </p>
                </div>

                <div className="text-[16px] leading-relaxed">
                  {/* Render Description */}
                  {Offer?.description ? (
                    <div
                      className="prose"
                      dangerouslySetInnerHTML={{ __html: Offer.description }}
                    />
                  ) : (
                    <p>No Description Available</p>
                  )}
                </div>
              </div>

              {/* Right Section */}
              <div>
                <div className="max-lg:hidden bg-no-repeat">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div>
              <div>
                <div className="border-b-2 my-5"></div>
                <div className="pt-5 flex justify-between items-center">
                  <div className="flex pb-5">
                    <Link to={"/dashboard"}>
                      <button className="flex items-center justify-center gap-1 font-semibold text-[20px] py-2 rounded-[10px] text-slate-500">
                        <FaAngleLeft />
                        Back
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Offers;
